import React, { useState, useEffect } from "react";
import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
import { getVideoGallery } from "../Service/Api";

function VideoGallery() {
  const [galleryData, setGalleryData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const data = await getVideoGallery();

        setGalleryData(data);

        const uniqueYears = [
          ...new Set(data.map((item) => new Date(item.date).getFullYear())),
        ].sort((a, b) => b - a);

        if (uniqueYears.includes(2026)) {
          setSelectedYear("2026");
        }
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };

    fetchGallery();
  }, []);

  // Fallback data when API is empty
  const galleryVideos = [
    {
      src: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/dummy.jpg",
      alt: "Carmel Sarangabad",
      title: "Category Name",
      date: "01/01/2026",
      description: "Stay tuned for latest videos",
      videoUrl: "#",
    },
  ];

  const videosToShow =
    galleryData && galleryData.length > 0 ? galleryData : galleryVideos;

  const years = [
    ...new Set(
      videosToShow
        .filter((item) => item.date)
        .map((item) => new Date(item.date).getFullYear()),
    ),
  ].sort((a, b) => b - a);

  const filteredData = videosToShow.filter((item) => {
    const dateObj = new Date(item.date);

    const yearMatch =
      selectedYear === "All" || dateObj.getFullYear() === Number(selectedYear);

    const monthMatch =
      selectedMonth === "All" ||
      dateObj.getMonth() + 1 === Number(selectedMonth);

    const searchMatch =
      !searchText ||
      item.title?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.description?.toLowerCase().includes(searchText.toLowerCase());

    return yearMatch && monthMatch && searchMatch;
  });

  return (
    <>
      <Header />
      {/* Breadcrumb Section */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Video "
          title2="Gallery"
          path="Video Gallery"
        />
      </div>

      <div className="innerbody">
        <div className="container-fluid">
          <div className="row tabs-dynamics mt-3">
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="filter-card count-card mb-2">
                <p>
                  Total Count <span>{filteredData.length}</span>
                </p>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="filter-card h-100">
                <select
                  className="form-select filter-select"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                >
                  <option value="All">All Years</option>

                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="filter-card h-100">
                <select
                  className="form-select filter-select"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                >
                  <option value="All">All Months</option>

                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={String(i + 1)}>
                      {new Date(0, i).toLocaleString("en-US", {
                        month: "short",
                      })}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Search */}
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-12">
              <div className="filter-card h-100">
                <input
                  type="text"
                  placeholder="Search gallery..."
                  className="form-control filter-input"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="row years year2024 showYear">
            {filteredData.length > 0 ? (
              filteredData.map((vid, idx) => (
                <div
                  key={idx}
                  className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-12 galleryCount"
                >
                  <div className="gallery-inner">
                    <div className="gallery-blks">
                      <div className="backDiv"></div>

                      <div className="video-inner video-thumb">
                        {vid.attachments?.length > 0 ? (
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${vid.attachments[0]}`}
                            alt={vid.alt || vid.title}
                            className="img-fluid"
                          />
                        ) : (
                          <img
                            src={
                              vid.src ||
                              "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/school-dummy.jpg"
                            }
                            alt={vid.alt || "Video Thumbnail"}
                            className="img-fluid"
                          />
                        )}

                        <a
                          href={vid.videoUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="inner-video-icon">
                            <i className="bi bi-play-circle-fill"></i>
                          </div>
                        </a>
                      </div>

                      <div className="gal-content">
                        <h4 className="gallery-title">{vid.title}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center py-5">
                <h5>No videos found.</h5>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default VideoGallery;
